module.exports = __webpack_public_path__ + "static/media/feather-sprite.b4dca014.svg";